module.exports = __webpack_public_path__ + "static/media/telegram.3f3f5201.svg";